import React from 'react'

const PageLoading =() => {
  return (
    <div className='loadingPage-container' style={{display:'flex',minHeight:'100vh',justifyContent:'center',alignItems:'center'}}>
        <div>
            <h3>Loading....</h3>
        </div>
    </div>
  )
}

export default PageLoading